// SLACK TIDE FOIL CLUB - theme.js

function toggleMute() {
  var video = document.getElementById("heroVideo");
  var btn = document.getElementById("muteBtn");
  if (!video || !btn) return;
  video.muted = !video.muted;
  btn.textContent = video.muted ? "[muted]" : "[sound]";
}

document.addEventListener("DOMContentLoaded", function() {
  var video = document.getElementById("heroVideo");
  if (video) video.play().catch(function() {});

  var signupBtn = document.getElementById("signup-btn");
  var emailInput = document.getElementById("email-input");
  if (signupBtn && emailInput) {
    signupBtn.addEventListener("click", function(e) {
      var email = emailInput.value.trim();
      var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
      if (!valid) {
        e.preventDefault();
        emailInput.style.background = "#fff8f8";
        emailInput.focus();
        setTimeout(function() { emailInput.style.background = ""; }, 2000);
      }
    });
  }

  document.addEventListener("keydown", function(e) {
    if (e.key !== "Escape") return;
    var modal = document.getElementById("notify-modal");
    if (modal) modal.classList.remove("open");
    var nav = document.querySelector(".nav-mobile");
    if (nav) nav.classList.remove("open");
  });
});
